// extracted by mini-css-extract-plugin
export default {"semiTitle":"item_semiTitle__aYDm-","lineButtons":"item_lineButtons__y7m2Z","headers":"item_headers__7we0a","twoInLine":"item_twoInLine__RFzKX","blokInputs":"item_blokInputs__sgcUD"};